import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CONTACT_CATS, API_URL } from "@/data/content";

export default function EnquiryForm({ defaultCategory = "General Enquiry", heading = "Send an Enquiry", sub, testidPrefix = "enquiry" }) {
    const [form, setForm] = useState({
        category: defaultCategory,
        name: "",
        email: "",
        phone: "",
        organisation: "",
        message: "",
    });
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const res = await axios.post(`${API_URL}/enquiries`, form);
            toast.success(res.data.message);
            setForm({ category: form.category, name: "", email: "", phone: "", organisation: "", message: "" });
        } catch {
            toast.error("Could not send your enquiry right now. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={submit} className="card-luxe p-8 md:p-10" data-testid={`${testidPrefix}-form`}>
            <div className="card-glow" />
            <h3 className="font-display text-2xl md:text-3xl text-[var(--ivory)]">{heading}</h3>
            {sub && <p className="mt-2 text-sm text-muted-luxe">{sub}</p>}
            <div className="mt-8 grid sm:grid-cols-2 gap-5">
                <div>
                    <label htmlFor={`${testidPrefix}-category`} className="label-luxe">Enquiry Type</label>
                    <select id={`${testidPrefix}-category`} value={form.category} onChange={set("category")} className="field" data-testid={`${testidPrefix}-category`}>
                        {CONTACT_CATS.map((c) => (
                            <option key={c} value={c}>{c}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor={`${testidPrefix}-name`} className="label-luxe">Full Name *</label>
                    <input id={`${testidPrefix}-name`} required value={form.name} onChange={set("name")} className="field" placeholder="Your name" data-testid={`${testidPrefix}-name`} />
                </div>
                <div>
                    <label htmlFor={`${testidPrefix}-email`} className="label-luxe">Email *</label>
                    <input id={`${testidPrefix}-email`} type="email" required value={form.email} onChange={set("email")} className="field" placeholder="you@example.com" data-testid={`${testidPrefix}-email`} />
                </div>
                <div>
                    <label htmlFor={`${testidPrefix}-phone`} className="label-luxe">Phone</label>
                    <input id={`${testidPrefix}-phone`} value={form.phone} onChange={set("phone")} className="field" placeholder="+91 ·····" data-testid={`${testidPrefix}-phone`} />
                </div>
                <div className="sm:col-span-2">
                    <label htmlFor={`${testidPrefix}-organisation`} className="label-luxe">Organisation</label>
                    <input id={`${testidPrefix}-organisation`} value={form.organisation} onChange={set("organisation")} className="field" placeholder="Company / institution (optional)" data-testid={`${testidPrefix}-organisation`} />
                </div>
                <div className="sm:col-span-2">
                    <label htmlFor={`${testidPrefix}-message`} className="label-luxe">Message *</label>
                    <textarea id={`${testidPrefix}-message`} required minLength={5} rows={4} value={form.message} onChange={set("message")} className="field resize-none" placeholder="Tell us how you'd like to be part of the bazaar…" data-testid={`${testidPrefix}-message`} />
                </div>
            </div>
            <button type="submit" disabled={busy} className="btn btn-gold mt-8 w-full sm:w-auto" data-testid={`${testidPrefix}-submit-btn`}>
                {busy ? "Sending…" : "Submit Enquiry"}
            </button>
        </form>
    );
}
